import React, { useEffect } from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import * as Notifications from 'expo-notifications';
import Login from '../components/Login';


const LoginScreen = ({setIsAuthenticated}) => {

  useEffect(() => {
    requestPermissions();
  }, []);

  const requestPermissions = async () => {
    if (Platform.OS === 'android') {
      await Notifications.setNotificationChannelAsync('default', {
        name: 'default',
        importance: Notifications.AndroidImportance.MAX,
      });
    }
    await Notifications.requestPermissionsAsync();
  };
  return (
    <View style={styles.container}>
      <Login setIsAuthenticated={setIsAuthenticated}/>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default LoginScreen;
